'use strict';

/**
 * @author Maxim Seredkin
 */
export default function() {
    return {
        restrict: 'A',
        template: require('../view/project-tab-attachments.html'),
        scope: {
            attachments: '=myModel',
            edit: '=edit',
        },
        controller: ['$scope',
                     function($scope) { }],
    };
}
